import { withStyles } from 'vopay';
import { Title, Button, Card } from 'UI';
import { useTranslation } from 'react-i18next';
import usePartnerCreationFormConfig, { SerializedPartnerCreationValues } from './usePartnerCreationFormConfig';
import styles from './PartnerCreationForm.module.scss';

const cn = withStyles(styles);

type PartnerCreationFormProps = {
  onSubmit: (values: SerializedPartnerCreationValues) => Promise<void>;
  creating: boolean;
  reviewing: boolean;
  onReviewChange: (reviewing: boolean) => void;
};

export default function PartnerCreationForm({
  onSubmit,
  creating,
  reviewing,
  onReviewChange,
}: PartnerCreationFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.Create' });
  const { ctx, renderFormElements, businessInfoConfig } = usePartnerCreationFormConfig({
    onSubmit,
    isReviewing: reviewing,
  });

  return (
    <form onSubmit={ctx.handleSubmit}>
      <Card variant="container">
        <div className={cn('detailsHeader')}>
          <Title level="3">{t('detailsTitle', { defaultValue: 'Details' })}</Title>
          <p className={cn('description')}>
            {t('detailsDescription', {
              defaultValue: 'Basic contact & business information for partner account creation.',
            })}
          </p>
        </div>
        <Card variant="section" className={cn('sectionCard')}>
          <Title level="4">{t('businessInformation', { defaultValue: 'Business Information' })}</Title>
          <div className={cn('grid')}>{renderFormElements({ config: businessInfoConfig })}</div>
        </Card>
        <div className={cn('footer')}>
          {reviewing ? (
            <>
              <Button type="button" onClick={() => onReviewChange(false)} disabled={creating}>
                {t('backButton', { defaultValue: 'Back' })}
              </Button>
              <Button type="submit" colorScheme="primary" disabled={!ctx.isValid || creating}>
                {t('confirmButton', { defaultValue: 'Confirm' })}
              </Button>
            </>
          ) : (
            <Button type="button" colorScheme="primary" disabled={!ctx.isValid} onClick={() => onReviewChange(true)}>
              {t('reviewButton', { defaultValue: 'Review' })}
            </Button>
          )}
        </div>
      </Card>
    </form>
  );
}
